export var DataHubActions;
(function (DataHubActions) {
    DataHubActions["ClickCreateModule"] = "click_create_module";
    DataHubActions["TryAddPageCover"] = "try_add_page_cover";
    DataHubActions["TryCreateModuleCover"] = "try_create_module_cover";
    DataHubActions["TryPageCreate"] = "try_page_create";
    DataHubActions["TryPagePublish"] = "try_page_publish";
    DataHubActions["TryPageUpdate"] = "try_page_update";
    DataHubActions["ViewBulkDelete"] = "view_bulk_delete_content";
    DataHubActions["ViewBulkPublish"] = "view_admin_bulk_publish";
    DataHubActions["ViewBulkUndoPublish"] = "view_bulk_undopublish";
    DataHubActions["ViewClassConfig"] = "view_class_config";
    DataHubActions["ViewContentCreate"] = "view_content_create";
    DataHubActions["ViewContentEdit"] = "view_content_edit";
    DataHubActions["ViewCoursePersonalization"] = "view_course_personalization";
    DataHubActions["ViewExtraMaterial"] = "view_extra_material";
    DataHubActions["ViewModuleCreate"] = "view_module_create";
    DataHubActions["ViewModuleCreateBottomsheet"] = "view_module_create_bottomsheet";
    DataHubActions["ViewPageAs"] = "view_page_as";
})(DataHubActions || (DataHubActions = {}));
